<template>
    <Modal :show-footer="false" :show-title="false" design="v3" @cancel="close">
        <div class="cancel-plan-information">
            <div class="svg-banner">
                <CancelPlan />
            </div>
            <div class="title">{{ $t("message.cancelPlanConfirmTitle") }}</div>
            <div class="description" v-if="planPeriod == 'monthly'">
                {{ $t("message.cancelPlanMonthlyDesc") }}
            </div>
            <div class="description" v-else>
                {{ $t("message.cancelPlanYearlyDesc") }}
            </div>

            <div class="footer">
                <SupsisButton class="footer-btn" @click="close">{{ $t("message.cancel") }}</SupsisButton>
                <SupsisButton class="footer-btn" danger @click="confirm">
                    <a-icon v-if="loading" type="loading" />
                    <span v-else>{{ $t("message.yesCancel") }}</span>
                </SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import CancelPlan from "../svg/CancelPlan.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "CancelPlanModal",
    components: {
        Modal,
        CancelPlan,
        SupsisButton,
    },
    props: {
        planPeriod: {
            type: String,
            default: "monthly",
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            if (this.loading) return;
            this.$emit("confirm");
        },
    },
};
</script>
<style lang="scss">
.cancel-plan-information {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .title {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        margin-top: 16px;
        color: var(--color-text-default);
    }

    .description {
        font-size: 16px;
        margin-top: 12px;
        text-align: center;
        color: var(--color-text-default);
        max-width: 420px;
        line-height: 1.6;
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-top: 24px;
    }

    .footer-btn {
        min-width: 140px;
        height: 44px;
    }
}

.svg-banner {
    width: 200px;
    height: 170px;

    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
